import { DetailedHTMLProps, ReactNode, SelectHTMLAttributes } from 'react';

type Option = {
  value: number | string;
  label: string;
}

type Props = {
  value: Option['value'] | null;
  options: Option[];
  onChange: (value: Option['value'] | null) => void;
  disabled?: boolean;
  label?: ReactNode;
} & DetailedHTMLProps<SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>;

/**
 * BST Styled Form Select Input
 * @param Props
 */
export const Select = ({
  label,
  value,
  options,
  onChange,
  ...rest
}: Props) => {
  return (
    <div className="form-control">
      {label && (
        <div className="form-label">{label}</div>
      )}
      <select
        {...rest}
        value={value || ""}
        className="input-control input-control__select"
        data-testid="select-control"
        onChange={(event) => onChange(event.target.value)}
      >
        {options.map(({ value, label }) => (
          <option key={value} value={value}>{label}</option>
        ))}
      </select>
    </div>
  );
};
